"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rarity = void 0;
var Rarity;
(function (Rarity) {
    Rarity[Rarity["None"] = 0] = "None";
    Rarity[Rarity["Common"] = 10] = "Common";
    Rarity[Rarity["Rare"] = 11] = "Rare";
    Rarity[Rarity["Epic"] = 12] = "Epic";
    Rarity[Rarity["Legendary"] = 13] = "Legendary";
    Rarity[Rarity["Mythic"] = 14] = "Mythic";
    Rarity[Rarity["Gen0"] = 100] = "Gen0";
})(Rarity = exports.Rarity || (exports.Rarity = {}));
